import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeListPage } from '../recipe-list/recipe-list';
import { RecipeCommon } from './recipe.common';
import { RecipeData } from '../../providers/recipe-data';
import { CategoryBoxesPage } from '../category-boxes/category-boxes';
@Component({
	selector: 'page-recipe',
	templateUrl: 'recipe.html'
})
export class RecipePage extends PageBase {
	public categories = [];

	public loader: any;
	public filteredItems: any;
	public pagedFilteredItems: any = [];
	public pageSize: number = 15;
	public hasMore = false;
	public showCategoriesList = false;
	public isLoading = false;

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public common: RecipeCommon,
		public events: Events,
		public recipeData: RecipeData,
		public loadingCtrl: LoadingController
	) {
		super(settings, events, nav, userData);
	}

	loadPage() {
		this.isLoading = true;
		// this.pagedFilteredItems.pus
		let start: number = this.pagedFilteredItems.length;
		let pageItems = _.slice(this.filteredItems, start, start + this.pageSize);
		Array.prototype.push.apply(this.pagedFilteredItems, pageItems);

		this.hasMore = this.pagedFilteredItems.length < this.filteredItems.length;
		this.isLoading = false;
	}

	loadMoreItems(infiniteScroll) {
		if (this.isLoading) {
			return;
		}
		this.loadPage();
		infiniteScroll.complete();
	}

	loadData() {
		this.filteredItems = [];
		this.loader.present();
		this.recipeData.getAllCategories().subscribe((categories) => {
			this.loader.dismiss();
			if (!categories || categories.length == 0) {
				return;
			}
			_.forEach(categories, category =>{
				category.totalRecipes = category.items?Object.keys(category.items).length:0;
			});
			
			this.filteredItems = categories;
			this.pagedFilteredItems = [];
			this.loadPage();
		});
	}

	ngAfterViewInit() {
	}

	selectCategory(category) {
		console.log(category);
		this.nav.push(RecipeListPage, { category: category, categoryUrlSlug: category.urlSlug });
	}
	selectRecipeBox() {
		this.nav.push(CategoryBoxesPage, {});
	}
	ionViewDidEnter() {
		this.loader = this.loadingCtrl.create();		
		this.loadData();
	}

	public showCategoris() {
		this.showCategoriesList = !this.showCategoriesList;
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe/recipe.ts